import { SiHtml5, SiAdobepremierepro, SiBootstrap, SiCss3, SiJavascript, SiReact, SiGithub, SiJquery, SiTailwindcss, SiPython, SiGnubash, SiSass, SiFigma } from "react-icons/si";
import {IoLogoNodejs} from "react-icons/io5";

const skillsList = [

  {
    "id": 1,
    "skill": "HTML",
    "icon": <SiHtml5 size={30} />,
  },
  {
    "id": 2,
    "skill": "CSS5",
    "icon": <SiCss3 size={30} />,
  },
  {
    "id": 3,
    "skill": "Javascript",
    "icon": <SiJavascript size={30} />,
  },
  {
    "id": 4,
    "skill": "Python",
    "icon": <SiPython size={30} />,
  },
  {
    "id": 5,
    "skill": "Bootstrap",
    "icon": <SiBootstrap size={30} />,
  },
  {
    "id": 6,
    "skill": "React",
    "icon": <SiReact size={30} />,
  },
  {
    "id": 7,
    "skill": "Github",
    "icon": <SiGithub size={30} />,
  },
  {
    "id": 8,
    "skill": "Jquery",
    "icon": <SiJquery size={30} />,
  },
  {
    "id": 9,
    "skill": "Tailwind",
    "icon": <SiTailwindcss size={30} />,
  },
  {
    "id": 14,
    "skill": "NodeJs",
    "icon": <IoLogoNodejs size={30} />,
  },
  {
    "id": 10,
    "skill": "Bash",
    "icon": <SiGnubash size={30} />,
  },
  {
    "id": 11,
    "skill": "SCSS",
    "icon": <SiSass size={30} />,
  },
  {
    "id": 12,
    "skill": "Figma",
    "icon": <SiFigma size={30} />,
  },
  {
    "id": 13,
    "skill": "Adobe Premier Pro",
    "icon": <SiAdobepremierepro size={30} />,
  },
  //  {
  //   "id": 14,
  //   "skill": "D3.js",
  //   "icon": <SiD3 size={30} />,
  // }

];

export default skillsList;